/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([], () => {

	/**
	 * @interface DashboardThemeAPI
	 * @classdesc API class that defines the user profile info accessible in a dashboard
	 */
	class DashboardThemeAPI {
		/**
		 * Gets the theme definition
		 * @param {String} [themeName="carbonGrey10"] - the name of the theme to load
		 * @return {Promise} resolves to the loaded theme definition or if failed to load - resolves to the default theme definition or throws error if failed again
		 */
		getThemeDefinition() {}
	}

	return DashboardThemeAPI;
});
